import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Search from "./Search";
import { getPollsList } from "../../store/slices/pollSlice";
import PollCell from "./PollCell";
import ParticipantModel from "../models/ParticipantModel";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CreatePoll from "../models/CreatePoll";
import UpdatePoll from "../models/UpdatePoll";
import PageLoader from "../Loader/PageLoader";
import OptionalInfoModel from "../models/OptionalInfoModel";

const Polls = () => {
    const dispatch = useDispatch();
    const { isLoading, filteredPolls, totalRecordsReach, isModelOpen, isSearching,isOptionalModelOpen, selectedPoll } = useSelector((state) => state.poll);
    const [page, setPage] = useState(1);
    const scrollContainerRef = useRef(null);
    const [createPollModel, setCreatePollModel] = useState(false);

    const loadMorePolls = () => {
        if (totalRecordsReach) return false;
        setPage((prevPage) => {
            const nextPage = prevPage + 1;
            dispatch(getPollsList({ page: nextPage, limit: 5 }));
            return nextPage;
        });
    };

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
    
        const handleScroll = () => {
            if (isLoading || isSearching) return;
    
            const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
            if (scrollTop + clientHeight >= scrollHeight - 50) {
                loadMorePolls();
            }
        };
    
        if (!isSearching) {
            scrollContainer.addEventListener("scroll", handleScroll);
        }
    
        // Cleanup
        return () => {
            scrollContainer.removeEventListener("scroll", handleScroll);
        };
    }, [isLoading, isSearching, totalRecordsReach]);
    

    return (
        <div className="polls-box">
            <Search />

            <div
                className="scrollable-container position-relative"
                ref={scrollContainerRef}
                style={{ overflow: "hidden auto" }}
            >
                {filteredPolls?.length > 0 ? (
                    filteredPolls.map((poll, index) => (
                        <PollCell key={poll.id || index} poll={poll} />
                    ))
                ) : !isLoading ? (
                    <div className="d-flex justify-content-center align-items-center p-4">
                        <span className="text-muted">No Record Found</span>
                    </div>
                ) : null}

                {isLoading && (
                    <PageLoader width={"2rem"} />
                )}
            </div>


            <div className="add_button">
                <AddCircleIcon className="plus_icon"
                    onClick={() => { setCreatePollModel(true) }}

                />
            </div>
            <ParticipantModel show={isModelOpen} />

            <CreatePoll show={createPollModel} onClose={() => { setCreatePollModel(false) }} />
            <UpdatePoll />
            <OptionalInfoModel heading="Optional Info" show={isOptionalModelOpen}  isPolls={true}/>
        </div>
    );
};

export default Polls;